/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowBadgeLeftFilled = createReactComponent("filled", "arrow-badge-left-filled", "IconArrowBadgeLeftFilled", [["path", { "d": "M17 6h-6a1 1 0 0 0 -.78 .375l-4 5a1 1 0 0 0 0 1.25l4 5a1 1 0 0 0 .78 .375h6l.112 -.006a1 1 0 0 0 .669 -1.619l-3.501 -4.375l3.5 -4.375a1 1 0 0 0 -.78 -1.625z", "key": "svg-0" }]]);

export { IconArrowBadgeLeftFilled as default };
//# sourceMappingURL=IconArrowBadgeLeftFilled.mjs.map
